module.exports = __webpack_public_path__ + "static/media/4.f0e598a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/workoutPreview/img/4.png
// module id = 2111
// module chunks = 0